import script from "./BackOfficeServiceRequirementsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./BackOfficeServiceRequirementsIndex.vue?vue&type=script&setup=true&lang=js"

import "./BackOfficeServiceRequirementsIndex.vue?vue&type=style&index=0&id=683af3d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683af3d8"]])

export default __exports__